const initialState = {
    orgchartData: {},
};
  
export default initialState;